import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Injectable({providedIn: 'root'})
export class NewProductService {
  private formValidity$ = new BehaviorSubject<boolean>(false);
  readonly isFormValid = this.formValidity$.asObservable();

  private isPublished$ = new BehaviorSubject<boolean | null>(null);
  readonly isPublished = this.isPublished$.asObservable();

  private isWingameProd$ = new BehaviorSubject<boolean | null>(null);
  readonly isWingameProd = this.isWingameProd$.asObservable();

  private saveForm$ = new BehaviorSubject<boolean>(false);
  readonly isSavingForm = this.saveForm$.asObservable();

  setFormValidity(state: boolean) {
    this.formValidity$.next(state);
  }

  setIsPublished(state: boolean) {
    this.isPublished$.next(state);
  }

  setIsWingameProd(state: boolean) {
    this.isWingameProd$.next(state);
  }

  setSaveForm(state: boolean) {
    this.saveForm$.next(state);
  }
}
